<div class="container" [id]="data?.details?.id">
  <h3>
    {{ data.details.title.split(" ")[0] }}
    <span> {{ data.details.title.split(" ")[1] }}</span>
  </h3>

  <p-carousel
    dir="ltr"
    [value]="groupedServices"
    [numVisible]="1"
    [numScroll]="1"
    [showIndicators]="true"
  >
    <ng-template let-projects pTemplate="item">
      <div class="row w-100">
        <div
          class="col-12 col-sm-6 col-md-4 p-3"
          *ngFor="let project of projects"
        >
          <div class="card">
            <img
              src="{{ project.imageIconPath }}"
              class="card-img-top"
              alt="{{ project.titleTr }}"
            />
            <div class="card-body" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
              <h4 class="card-title">{{ project.titleTr }}</h4>
              <p class="card-text" [innerHTML]="project.summary"></p>
            </div>
            <a
              *ngIf="data.details.isDetails"
              [href]="getDetailsUrl(project)"
              class="btn"
            >
              {{ "read more" | translate }}
            </a>
          </div>
        </div>
      </div>
    </ng-template>
  </p-carousel>
</div>
